import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="h-32 bg-[var(--color-bg-surface)] border-t border-[var(--color-border-subtle)] mt-auto">
      <div className="h-full max-w-[1280px] mx-auto px-8 flex items-center justify-between">
        {/* Logo - exact match from Figma */}
        <Link
          to="/"
          className="flex items-center gap-1 focus:outline-none focus:ring-2 focus:ring-[#FF6900] focus:ring-offset-2 rounded-sm"
        >
          <img src="/images/logo-icon.svg" alt="" className="h-8 w-auto" aria-hidden="true" />
          <img src="/images/logo-text.svg" alt="chatable" className="h-[22px] w-auto dark:invert" />
        </Link>

        {/* Copyright and Legal Links */}
        <div className="flex items-center gap-4 text-sm text-[var(--color-text-secondary)]">
          <p>© 2025 Chatable Media · All rights reserved</p>
          <span aria-hidden="true">·</span>
          <Link
            to="/privacy"
            className="hover:text-[var(--color-brand-500)] transition-colors focus:outline-none focus:ring-2 focus:ring-[#FF6900] focus:ring-offset-2 rounded-sm"
          >
            Privacy Policy
          </Link>
          <span aria-hidden="true">·</span>
          <Link
            to="/terms"
            className="hover:text-[var(--color-brand-500)] transition-colors focus:outline-none focus:ring-2 focus:ring-[#FF6900] focus:ring-offset-2 rounded-sm"
          >
            EULA
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
